module.exports = __webpack_public_path__ + "img/start.4d9fa5d6.svg";